<template>
  <div class="">


    <div class="load" v-if="spinning == true">
      <a-spin :spinning="spinning" tip="Loading..."></a-spin>
    </div>

    <div id="components-form-demo-advanced-search">
      <a-form
              class="ant-advanced-search-form"
              :form="form"
              @submit="handleSearch"
      >
        <a-row :gutter="24">


          <a-col span="8">
            <a-form-item label="日期：">
              <a-range-picker
                      show-time
                      format="YYYY/MM/DD"
                      :value="[this.moment(createValue[0], dateFormat),this.moment(createValue[1], dateFormat)]"
                      @change="onDateChange"
              />
            </a-form-item>
          </a-col>

          <a-col :span="4">
            <a-form-item label="错误状态：">
              <a-select v-model="param.status" placeholder="请选择" @change="statusChange">
                <a-select-option value="">全部</a-select-option>
                <a-select-option :value="item.value" v-for="(item,index) in statusList" :key="index">
                  {{ item.desc }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>


          <a-col :span="4" :style="{ textAlign: 'right' }">
            <a-button type="primary" html-type="submit">
              查询
            </a-button>
          </a-col>

          <a-col :span="24" :style="{ textAlign: 'right' }">
<!--            <a-button v-if="dataList!=null && dataList.length > 0" type="primary" :style="{ marginLeft: '8px' }" @click="toConfirmAll">-->
<!--              全部确认-->
<!--            </a-button>-->
<!--            <a-button v-if="dataList!=null && dataList.length > 0" type="primary" :style="{ marginLeft: '8px' }" @click="toCancelAll">-->
<!--              全部忽略-->
<!--            </a-button>-->
          </a-col>
        </a-row>
      </a-form>
      <!-- 表格 -->
      <div class="table">
        <a-table
                :columns="columns"
                :dataSource="dataList"
                :pagination="pagination"
                rowKey="id"
                @change="TableChange"
        >
          <template slot="serial" slot-scope="text, record, index">
            <template>
              {{ ((pagination.current - 1)*pagination.pageSize) + (index+1) }}
            </template>
          </template>
          <a slot="name" slot-scope="text">{{ text }}</a>

          <template slot="status" slot-scope="text, record, index">
            <template>
              {{text | statusFilter}}
            </template>
          </template>


          <template slot="opera" slot-scope="text,record">
            <a-tag slot="opera" color="green" @click="toView(record)"  style="cursor: pointer;">
              查看详情
            </a-tag>


            <a-tag v-if="record.status == 0" slot="opera" color="green" @click="toConfirm(record)"  style="cursor: pointer;">
              处置
            </a-tag>
            <a-tag v-if="record.status == 0" slot="opera" color="volcano" @click="toCancel(record)"  style="cursor: pointer;">
              忽略
            </a-tag>
          </template>
        </a-table>

      </div>
    </div>

  </div>
</template>
<script>

import { errorList,deleteError,errorConfirm,errorCancel,errorConfirmAll } from '@/api/wall/error'

import {formatTime} from '@/utils/time'
import moment from 'moment'

const columns = [
  {
    title: "序号 ",
    dataIndex: "serial",
    key: "serial",
    align: "center",
    scopedSlots: { customRender: 'serial' }
  },
  {
    title: "错误id ",
    key: "errorTypeName",
    dataIndex: "errorTypeName",
    align: "center"
  },
  {
    title: "数据表 ",
    key: "checkTableName",
    dataIndex: "checkTableName",
    align: "center"
  },
  {
    title: "数据 ",
    key: "checkDataName",
    dataIndex: "checkDataName",
    align: "center"
  },
  {
    title: "KEYID ",
    key: "checkDataId",
    dataIndex: "checkDataId",
    align: "center"
  },
  {
    title: "数据状态",
    key: "status",
    align: "center",
    dataIndex: "status",
    scopedSlots: { customRender: 'status' }
  },
  {
    title: "操作 ",
    key: "opera",
    dataIndex: "opera",
    align: "center",
    scopedSlots: { customRender: "opera" }
  }
];

const dataList = [
];

export default {
  data() {
    return {
      moment,
      dateFormat: "YYYY/MM/DD HH:mm:ss",
      pagination: {
        current: 1,
        pageNo: 1,
        pageSize: 10, // 默认每页显示数量
        showSizeChanger: true, // 显示可改变每页数量
        pageSizeOptions: ['10', '20', '30'], // 每页数量选项
        showTotal: total => `共有 ${total} 条`, // 显示总数
        //onChange: (page, pageSize) => this.changePage(page, pageSize), // 点击页码事件
        total: 0 // 总条数
      },

      form: this.$form.createForm(this, {
        name: "" ,
      }),
      param:{
        size: 10,
        page: 1,
        checkType: "" ,
        startDate: undefined,
        endDate: undefined,
        status:"",
      },
      dataList,
      columns,

      spinning: false,
      userName: "",

      id: 0,

      trueList: [
        {value: 0,desc: '否'},
        {value: 1,desc: '是'}
      ],

      statusList: [
        {value: 1,desc: '已处置'},
        {value: 2,desc: '已忽略'},
      ],

      createValue: [],
    };
  },
  computed: {
  },
  filters: {
    statusFilter (status) {
      if(status === 1)
        return "已处置"
      else if(status === 2)
        return "已忽略"
      else if(status === 99)
        return "错误99"
      else if(status === 98)
        return "错误98"
      else if(status === 89)
        return "错误89"
      else if(status === 3)
        return "错误3"
      else
        return "待处置"
    },
    trueFilter (status) {
      if(status === 0)
        return "否"
      else if(status === 1)
        return "是"
      else
        return "否"
    },
    formatDate(status) {
      return formatTime(status, "{y}-{m}-{d}")
    },
    formatTime(status) {
      return formatTime(status, "{y}-{m}-{d} {h}:{i}:{s}")
    },
  },
  created() {
    var startDate = Date.now();
    this.param.startDate = formatTime(startDate, '{y}-{m}-{d} 00:00:00')
    this.param.endDate = formatTime(startDate, '{y}-{m}-{d} 23:59:59')
    this.createValue = [this.param.startDate, this.param.endDate]

    var userId = localStorage.getItem("userId")
    // 获取当前账号信息
    // this.param.status = userId

    this.getList(0);
  },
  updated() {
    console.log("updated");
  },
  methods: {


    getList(number) {
      if (number === 0) {
        this.pagination.current = 1
        this.param.page = 1
      }

      var param = this.param
      errorList(param).then(response => {

        this.dataList = response.data.list
        if (this.dataList) {
          this.pagination.total = response.data.total
        }
        else
        {
          this.pagination.total = 0
        }
      })
    },

    // 搜索
    handleSearch(e) {

      e.preventDefault();

      this.form.validateFields((error, values) => {
        console.log("error", error);
        console.log("Received values of form: ", values);
      });

      this.getList(0);
    },

    statusChange (value) {
      this.param.status = value

      this.getList(0)
    },

    //确认
    toConfirm(value) {
      let self = this
      this.id = value.id;
      this.$confirm({
        title: '确认提示',
        content: `是否已处理异常的数据？`,
        okType: 'danger',
        okText: '确定',
        cancelText: '取消',
        onOk () {

          self.spinning = true

          errorConfirm({
            id: self.id
          }).then(res => {
            console.log(res);

            self.spinning = false

            if(res.code == 0)
            {
              self.$message.success("确认完成", function() {
                self.getList(0);
              });
            }
            else
            {
              self.$message.error(res.message)
            }
          }).catch(err => {

            self.spinning = false

            self.$message.error(err.message);
          })
        },
        onCancel () {

        }
      })
    },
    //确认
    toCancel(value) {
      let self = this
      this.id = value.id;
      this.$confirm({
        title: '确认提示',
        content: `是否忽略异常数据？`,
        okType: 'danger',
        okText: '确定',
        cancelText: '取消',
        onOk () {

          self.spinning = true

          errorCancel({
            id: self.id
          }).then(res => {

            self.spinning = false

            self.$message.success("操作成功", function() {
              self.getList(0);
            });
          }).catch(err => {

            self.spinning = false

            self.$message.error(err.message);
          })
        },
        onCancel () {

        }
      })

    },

    onDateChange(date, dateString) {
      this.createValue = date
      this.param.startDate = dateString[0]
      this.param.endDate = dateString[1]
      this.getList(0);
    },

    //新建/编辑/查看
    toView(value) {
      console.log(value);
      this.id = value.id;

    },

    TableChange (e) {
      // 每页数量变更
      this.pagination.current = e.current
      this.param.page = e.current
      this.param.size = e.pageSize
      this.getList()
    },
    changePage (page, pageSize) {
      // 页码变更
      this.pagination.current = page
      this.param.page = page
      this.param.size = pageSize
      this.getList()
    },
  }
};
</script>
<style scoped>
  .ant-advanced-search-form {
    padding: 24px;
    background: #ffffff;
    /* border: 1px solid #d9d9d9; */
    /* border-radius: 6px; */
  }

  .ant-advanced-search-form .ant-form-item {
    display: flex;
  }

  .ant-advanced-search-form .ant-form-item-control-wrapper {
    flex: 1;
  }

  #components-form-demo-advanced-search .ant-form {
    max-width: none;
  }
  #components-form-demo-advanced-search .search-result-list {
    margin-top: 16px;
    border: 1px dashed #e9e9e9;
    border-radius: 6px;
    background-color: #ffffff;
    min-height: 200px;
    text-align: center;
    padding-top: 80px;
  }
  .table {
    margin-top: 20px;
    background: #ffffff;
    padding: 20px;

  }
  /deep/ .ant-table-tbody > tr > td {
    padding: 5px 5px!important;
  }

  .load {
    width:100%;
    height:100%;
    background-color:#000;
    position:absolute;
    top:0;
    left:0;
    z-index:2;
    opacity:0.3;
    /*兼容IE8及以下版本浏览器*/
    filter: alpha(opacity=30);

    display: flex;
    align-items: center;
    justify-content: center;

  }
</style>
